// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const RemediationPrLinkReasonSchema = z.enum(['terra_remediate','ticket','customer_remediation'] as const);

export type RemediationPrLinkReasonType = `${z.infer<typeof RemediationPrLinkReasonSchema>}`

export default RemediationPrLinkReasonSchema;
